import React from 'react';
import { Box, Grid, styled, Typography, useMediaQuery, Button } from '@mui/material';
import ApiConf from './../images/speaking/apiconference.png';
import Policy from './../images/speaking/kwarabuild2025.JPG';
import Nacos from './../images/speaking/nacos_tech_fest.JPG';
import WTM from './../images/speaking/WomentechMakers.jpg';
import OtherSpeakingEngagements from './OtherSpeakingEngagements';


const Speaking = () => {
    // hook from MUI to check for media query of this value
    const desktopView = useMediaQuery('(min-width:1093px)');

    const CTA = styled(Button)`
        font-size: 15px;
        font-family: 'Oswald';
        border: 1px solid black;
        color: black;
        padding: 20px;
        margin-top: 12px;
        &:hover {
            background-color: black;
            color: white;
            cursor: pointer;
        }
    `;

    const SpeakingItem = styled(Grid)`
        max-height: 1000px;
        width: 30%;
    `;

    const SpeakingMobileItem = styled(Grid)`
        max-height: 1000px;
        width: 100%;
    `;

    const Image = styled('img')`
        width: 100%;
        height: 250px;
        object-fit: cover;
        text-align: center;
    `;

    // speaking engagement data
    const speakingData = [
        {
            id: 1,
            title: "Mastering APIs as a Product Manager: Calling, Documenting, and Testing APIs",
            organizer: 'API Lagos Conference 2025',
            url: 'https://www.youtube.com/watch?v=2aJtcNYd1bI',
            image: ApiConf,
            cta: 'watch session',
            role: "Speaker",
            organizer_url: "https://apiconf.net/",
        },
        {
            id: 2,
            title: 'Policy for Progress: Creating an Africa Where Startups Thrive',
            organizer: 'Kwara Build',
            // url: 'https://drive.google.com/file/d/14Uv1mijKxFkMLhNJgCUyZEyRrWFOwNxM/view?usp=sharing',
            url: 'https://www.youtube.com/watch?v=TAxAz6RqFoI&t=145s',
            image: Policy,
            cta: 'listen to session ',
            role: "Moderator",
            organizer_url: "https://kwarabuild.org/kbtc25",
        },
        {
            id: 3,
            title: 'Tech for Good: Creating Solutions for a Better World',
            organizer: 'NACOS UNILORIN',
            url: 'https://www.youtube.com/watch?v=TfNtg-eXqsM&t=3996s',
            image: Nacos,
            cta: 'check out session  ',
            role: "Panelist",
            organizer_url: "https://nacoss.framer.website/",
        },
        {
            id: 4,
            title: 'Working with AI',
            organizer: 'WomenTechMakers Ilorin',
            url: 'https://x.com/bhalow_meenat/status/1917512753818001594?s=20',
            image: WTM,
            cta: 'learn more',
            role: "Panelist",
            organizer_url: "https://x.com/wtmilorin?lang=en",
        }
    ];


    return (
        <>
            <br/><br/><br/><br/><br/><br/>
            <Box>
                <Grid container columnSpacing={3} rowSpacing={3} className={desktopView ? 'project-grid-container-desktop' : 'project-grid-container'}>
                    {speakingData.map((item, index) => {
                        return (
                            desktopView ? (
                                <SpeakingItem item key={index}>
                                    <Image alt={item.title} src={item.image}/>
                                    <br/>
                                    <Typography style={{fontFamily: 'Oswald', fontSize: '22px', letterSpacing: '2px', lineHeight: '2'}}>
                                        {item.title.toUpperCase()}
                                    </Typography>
                                    <br/>
                                    <Typography style={{fontSize: '16px', color: 'black'}}>
                                       <b> {item.role} </b>  | <b>By:</b> <a href={item.organizer_url} target="_blank" rel="noopener noreferrer">  {item.organizer} </a>
                                    </Typography>
                                    <br/>
                                    <a href={item.url} target="_blank" rel="noopener noreferrer"
                                        style={{textDecoration: 'none', color: 'black'}}
                                    >
                                        <CTA>
                                            {item.cta.toUpperCase()}
                                        </CTA>
                                    </a>
                                </SpeakingItem>
                            ) : (
                                <SpeakingMobileItem item key={index}>
                                    <Image alt={item.title} src={item.image}/>
                                    <br/>
                                    <Typography style={{fontFamily: 'Oswald', fontSize: '22px', letterSpacing: '2px', lineHeight: '2'}}>
                                        {item.title.toUpperCase()}
                                    </Typography>
                                    <br/>
                                    <Typography style={{fontSize: '16px', color: '#666'}}>
                                        {item.role} | <b>By:</b> <a href={item.organizer_url} target="_blank" rel="noopener noreferrer">  {item.organizer} </a>
                                    </Typography>
                                    <br/>
                                    <a href={item.url} target="_blank" rel="noopener noreferrer"
                                        style={{textDecoration: 'none', color: 'black'}}
                                    >
                                        <CTA>
                                            {item.cta.toUpperCase()}
                                        </CTA>
                                    </a>
                                </SpeakingMobileItem>
                            )
                        )
                    })}
                </Grid>
            </Box>
            <OtherSpeakingEngagements/>
        </>
    )
}

export default Speaking;